import React from 'react';
import { injectIntl, type IntlShape } from '@atlassian/jira-intl';

import messages from '@atlassian/jira-portfolio-3-portfolio/src/common/view/messages';
import LegendContainer from '../legend-container';
import LegendItem from '../legend-item';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from '../styles.module.css';
import type { Props } from './types';

function IssueTypesLegend({
	intl,
	issueTypeLegendItems,
}: Props & {
	intl: IntlShape;
}) {
	if (!issueTypeLegendItems || issueTypeLegendItems.length <= 0) {
		return null;
	}

	return (
		<LegendContainer title={intl.formatMessage(messages.issueType)}>
			{issueTypeLegendItems.map((legendItem, index) => (
				<LegendItem key={index}>
					{
						// eslint-disable-next-line @typescript-eslint/no-shadow
						legendItem.iconUrls.map((iconUrl, index) => (
							// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
							<img alt="" key={index} className={styles.legendItemIcon} src={iconUrl} />
						))
					}
					{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
					<div className={styles.legendItemText}>{legendItem.name}</div>
				</LegendItem>
			))}
		</LegendContainer>
	);
}

export default injectIntl(IssueTypesLegend);
